"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import _ from "underscore";
import Auth from "../util/auth";
import Api from "../api/api";
import ExceptionSender from "./exception_sender";
import LoadEmailCreator from "./load_email_creator";
import FactorInvoicesService from "./factor_invoices_service";
import LoadsService from "./loads_service";
import DocumentsService from "./documents_service";
import CarrierInvoicesStore from "../stores/carrier_invoices_store";
import CarrierService from "../services/carrier_service";
import WaitingSpinner from "../components/waiting_spinner";
import { DocumentBatchGroupCreator } from "./document_batch_group_creator";
function findEmail(emailId, emailMessages) {
  if (emailId) {
    return emailMessages.find((e) => e.id === emailId) || null;
  }
  return emailMessages[0] || null;
}
function carrierOrNull(carrierId) {
  if (!carrierId) {
    return Promise.resolve(null);
  }
  return CarrierService.carrierWithId(carrierId).then(
    (carrier) => carrier,
    () => null
  );
}
function factoringCompanyOrNull(carrierInvoiceId) {
  return Api.FactoringCompanies.byCarrierInvoiceId(carrierInvoiceId).then(
    (data) => {
      var _a;
      return ((_a = data == null ? void 0 : data.factoring_companies) == null ? void 0 : _a[0]) || null;
    },
    () => null
  );
}
function fetchFactorInvoice(factorInvoiceId) {
  return FactorInvoicesService.fetchWithID(factorInvoiceId).then((data) => {
    const factorInvoice = data.factor_invoice;
    return carrierOrNull(
      factorInvoice.carrier_id || factorInvoice.tms_carrier_id
    ).then((carrier) => ({
      invoice: factorInvoice,
      loadState: null,
      carrier,
      factoringCompany: null,
      documents: data.documents || [],
      emailMessages: factorInvoice.email_messages || []
    }));
  });
}
function carrierInvoiceDocuments(documentBatches, carrierInvoiceId, loadState) {
  const showsLoadDocuments = Api.Account.showAllLoadDocumentsEnabled();
  const groups = new DocumentBatchGroupCreator(
    documentBatches,
    (doc) => doc.carrier_invoice_id === carrierInvoiceId || showsLoadDocuments && !doc.carrier_invoice_id && loadState.document_ids.includes(doc.id)
  ).groups;
  return _.flatten(_.pluck(_.values(groups), "documents"));
}
function fetchCarrierInvoice(carrierInvoiceId, loadStateId) {
  return Promise.all([
    // Forced: the invoice was just parked, so a cached load would carry its old failures.
    LoadsService.forceGetLoad(loadStateId),
    factoringCompanyOrNull(carrierInvoiceId)
  ]).then(
    ([loadState, factoringCompany]) => DocumentsService.getDocumentBatches(
      loadState.document_batch_ids,
      () => false
    ).then((documentBatches) => {
      const carrierInvoice = CarrierInvoicesStore.find(carrierInvoiceId);
      return carrierOrNull(
        (carrierInvoice == null ? void 0 : carrierInvoice.carrier_id) || loadState.load.carrier_id
      ).then((carrier) => ({
        invoice: carrierInvoice,
        loadState,
        carrier,
        factoringCompany,
        documents: carrierInvoiceDocuments(
          documentBatches,
          carrierInvoiceId,
          loadState
        ),
        emailMessages: _.compact(_.pluck(documentBatches, "email_message"))
      }));
    })
  );
}
function fetchInvoice(invoice) {
  switch (invoice.kind) {
    case "factor":
      return fetchFactorInvoice(invoice.factorInvoiceId);
    case "carrier":
      return fetchCarrierInvoice(invoice.carrierInvoiceId, invoice.loadStateId);
  }
}
var ExceptionSenderWrapper = React.createClass({
  getInitialState: function() {
    return {
      loading: true,
      invoice: null,
      loadState: null,
      carrier: null,
      factoringCompany: null,
      documents: [],
      emailMessages: [],
      error: null
    };
  },
  componentDidMount: function() {
    this.fetchData();
  },
  fetchData: function() {
    fetchInvoice(this.props.invoice).then(
      (fetched) => {
        this.setState(__spreadValues({ loading: false }, fetched));
      },
      (error) => {
        this.setState({ loading: false, error: "Failed to load invoice data" });
        return Promise.reject(error);
      }
    );
  },
  render: function() {
    var _a;
    if (this.state.loading) {
      return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: true });
    }
    if (this.state.error) {
      return /* @__PURE__ */ React.createElement("div", { className: "exception-sender__error" }, this.state.error);
    }
    const {
      invoice,
      loadState,
      carrier,
      factoringCompany,
      documents,
      emailMessages
    } = this.state;
    if (!(invoice == null ? void 0 : invoice.active_exceptioned_item)) {
      return /* @__PURE__ */ React.createElement("div", { className: "exception-sender__error" }, "No active exception found for this invoice.");
    }
    const email = findEmail(this.props.emailId, emailMessages);
    if (this.props.emailId && !email) {
      return /* @__PURE__ */ React.createElement("div", { className: "exception-sender__error" }, "The email for this exception was not found.");
    }
    const settings = Api.Account.currentSettings() || {};
    const templateVariables = (_a = Api.Account.current()) == null ? void 0 : _a.payables_template_variables;
    const { queuedMessages } = this.props;
    const isFactor = this.props.invoice.kind === "factor";
    const invoiceForTemplate = isFactor && queuedMessages.length > 0 ? __spreadProps(__spreadValues({}, invoice), {
      exception_events: queuedMessages.map((msg) => ({
        message_override: msg
      })),
      failure_messages: []
    }) : invoice;
    const contacts = !isFactor && settings.only_show_load_contacts_for_exception_emails ? [] : (carrier == null ? void 0 : carrier.contacts) || [];
    const defaultEmail = new LoadEmailCreator(
      loadState,
      invoiceForTemplate,
      Auth._currentUser,
      settings.custom_exception_email_subject_template || "",
      settings.custom_exception_email_body_template || "",
      templateVariables || [],
      carrier
    ).initialEmail();
    return /* @__PURE__ */ React.createElement(
      ExceptionSender,
      {
        key: email == null ? void 0 : email.id,
        documents,
        onComplete: this.props.onComplete,
        defaultEmail,
        possibleLoad: loadState,
        parent: email,
        parentId: email == null ? void 0 : email.id,
        contacts,
        canCancel: true,
        cancel: this.props.onCancel,
        exceptionedItemId: invoice.active_exceptioned_item.id,
        carrierInvoice: invoice,
        carrier,
        factoringCompany,
        multipleExceptionMessagesEnabled: settings.multiple_custom_exception_templates,
        customEmailTemplates: settings.custom_exception_email_templates,
        templateVariables
      }
    );
  }
});
export default ExceptionSenderWrapper;
